export default __webpack_public_path__ + "static/bannerPubliMBDO-b41fa8d7a6daa4f8c0dc15a964ff85fb.png";